'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import allLogo from './Assets/logos.PNG';

var About = function (_Component) {
  (0, _inherits3.default)(About, _Component);

  function About() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, About);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = About.__proto__ || (0, _getPrototypeOf2.default)(About)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(About, [{
    key: 'render',
    value: function render() {
      // Two new logos on the About page
      var allLogo = require('./Assets/logos.png');
      var styles = require('./About.scss');

      return _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement(
          'div',
          { className: styles.aboutPage },
          _react2.default.createElement(
            'h1',
            null,
            'About Us'
          ),
          _react2.default.createElement(_reactHelmet2.default, { title: 'About Us' }),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'strong',
              { className: styles.orangeText },
              'Reboot Kids'
            ),
            ' is a behavioural intervention to prevent cardiometabolic complications in childhood cancer survivors by improving fruit and vegetable intake.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Developed by researchers from the Behavioural Sciences Unit (BSU) at the Kids Cancer Centre, Sydney Children\'s Hospital (SCH) and the ',
            _react2.default.createElement(
              'a',
              { href: 'http://www.gsbme.unsw.edu.au', target: '_blank' },
              'Graduate School of Biomedical Engineering (GSBmE)'
            ),
            ' at UNSW Sydney.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'The University of New South Wales is a partner of the Sydney Children\'s Hospital Network, which includes SCH, and supports research undertaken at the Hospital.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Kids Cancer Alliance (KCA) funded the development of Reboot Kids ',
            _react2.default.createElement('br', null),
            'Cancer Council New South Wales (CCNSW) funded Reboot Kids Pilot ',
            _react2.default.createElement('br', null),
            'The Kids\u2019 Cancer Project (TKCP) is funding Reboot Kids RCT'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'strong',
              { className: styles.orangeText },
              'Reboot Kids'
            ),
            ' ',
            _react2.default.createElement(
              'b',
              null,
              'is proudly supported by:'
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.Col,
            null,
            _react2.default.createElement(ReactBootstrap.Image, { src: allLogo, fluid: true, responsive: true })
          ),
          _react2.default.createElement(
            'h1',
            null,
            'Contact us'
          ),
          _react2.default.createElement(
            'p',
            null,
            'You can contact us by emailing: ',
            _react2.default.createElement(
              'strong',
              null,
              'reboot@unsw.edu.au'
            )
          ),
          _react2.default.createElement(
            'h1',
            null,
            'Where are we?'
          ),
          _react2.default.createElement('iframe', { src: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1655.4659856848398!2d151.23718145826024! 3d-33.91715039516066!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12b218afaa2dbf%3A0xb4e18d4555a9017d! 2sSydney+Children\'s+Hospital!5e0!3m2!1sen!2sau!4v1502008339346', width: '100%', height: 350, frameBorder: 0, allowFullScreen: true })
        )
      );
    }
  }]);
  return About;
}(_react.Component);

exports.default = About;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/About/About.js
// module id = 1269
// module chunks = 0